<template>
  <div id="login">
    <div class="login f isPC" style="padding:0;">
      <div class="login-left">
        <div class="head">
          <!-- <div class="logo pointer" @click="$router.push('/home')"><img src="@/assets/img/logo.png" /></div> -->
          <div class="logo pointer" @click="jump('/')"><img src="@/assets/img/logo.png" /></div>
        </div>
        <div class="content f-c">
          <!-- 登录 -->
          <div v-show="!forgetPass" class="login-box f--c fd-c">
            <h4>Sign In</h4>
            <div style="color:#909399;">
              Don‘t have an account?
              <el-button type="text" @click="$router.push('/register')">Sign Up</el-button>
            </div>
            <el-form label-position="top" label-width="80px" :model="userForm" :rules="rules" ref="loginForm" class="login-form" @submit.native.prevent>
              <el-form-item v-if="loginMethod === 'email'" :label="$t('Home.Login.EmailID')" prop="username">
                <el-input v-model.trim="userForm.username" :placeholder="$t('Home.Login.EmailID')"></el-input>
              </el-form-item>
              <el-form-item v-else :label="$t('Home.Login.PhoneNumber')" prop="phone">
                <el-input v-model.trim="userForm.phone" @input="checkPhone" :placeholder="$t('Home.Register.PhoneNumber')">
                  <el-select v-model="userForm.areaCode" filterable slot="prepend" style="width:88px;">
                    <el-option v-for="item in areaCodeList" :label="item.areaCode" :value="item.areaCode" :key="item.countryCode+item.areaCode">
                      <span style="float:left;font-size:13px;color:#909399;">{{ item.countryNameEn }}</span>
                      <span style="float:right;font-size:13px;color:#303133;">{{item.areaCode}}</span>
                    </el-option>
                  </el-select>
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <div slot="label" class="f-b-c" style="width:100%">
                  <div>{{ $t('Home.Login.Password') }}</div>
                  <el-button type="text" style="padding: 0" @click="handleForgetPass">{{ $t('Home.Login.ForgetThePassword') }}</el-button>
                </div>
                <el-input type="password" v-model.trim="userForm.password" show-password :placeholder="$t('Home.Login.Password')" @keyup.enter.native="handleLogin"></el-input>
              </el-form-item>
              <el-form-item>
                <el-checkbox v-model="checked">{{ $t('Home.Login.RememberMe') }}</el-checkbox>
              </el-form-item>
              <el-form-item style="margin-bottom:0;">
                <el-button :loading="loadingBtn" type="primary" class="login-btn" @click="handleLogin">{{ $t('Home.Login.SignIn') }} <i class="el-icon-right"></i></el-button>
              </el-form-item>
            </el-form>
            <div style="width:100%">
              <LoginMethod :loginMethod="loginMethod" @clickGoogle="isClickGoogle = true" @changeLoginMethod="changeLoginMethod"></LoginMethod>
              <div class="terms">By creating the account, I agree to KakaClo’s
                <span class="pointer color-green" @click="jump('/terms-conditions')">Terms & Conditions, </span>
                <span class="pointer color-green" @click="jump('/privacy-policy')">Privacy Policy</span>
                and fees and cancellation
              </div>
            </div>
          </div>

          <!-- 忘记密码 -->
          <div v-show="forgetPass" class="login-box f--c fd-c">
            <div class="back color-green pointer" @click="backLogin"><i class="el-icon-arrow-left"></i> Back</div>
            <h4>Reset Your Password</h4>
            <el-form v-if="!resetPass" label-position="top" label-width="80px" ref="forgetForm" :model="forgetForm" :rules="rules" class="login-form">
              <el-form-item v-if="loginMethod === 'email'" :label="$t('Home.Login.EmailID')" prop="email">
                <el-input v-model.trim="forgetForm.email"></el-input>
              </el-form-item>
              <el-form-item v-else :label="$t('Home.Login.PhoneNumber')" prop="phone">
                <!-- <el-input v-model.trim="userForm.phoneNumber" :placeholder="$t('Home.Login.PhoneNumber')"></el-input> -->
                <el-input v-model.trim="forgetForm.phone" @input="checkForgetPhone" :placeholder="$t('Home.Register.PhoneNumber')">
                  <el-select v-model="forgetForm.areaCode" filterable slot="prepend" style="width:88px;">
                    <el-option v-for="item in areaCodeList" :label="item.areaCode" :value="item.areaCode" :key="item.countryCode+item.areaCode">
                      <span style="float:left;font-size:13px;color:#909399;">{{ item.countryNameEn }}</span>
                      <span style="float:right;font-size:13px;color:#303133;">{{item.areaCode}}</span>
                    </el-option>
                  </el-select>
                </el-input>
              </el-form-item>
              <el-form-item :label="$t('Home.Login.VerificationCode')" prop="verificationCode" class="verification">
                <el-input style="margin-right:2%" v-model.trim="forgetForm.verificationCode" @blur="checkVerificationCode"></el-input>
                <!-- <el-input v-model.trim="userForm.verificationCode"></el-input> -->
                <span class=" pointer" size="large" @click="sendVertificationCode" v-if="seconds===0">
                  <el-button class="send-button" :loading="loading">{{ $t('Home.Login.Send') }}</el-button>
                </span>
                <el-button class="send-button" disabled v-else>{{seconds}}S</el-button>
              </el-form-item>
              <el-form-item style="padding-top:20px">
                <el-button type="primary" class="login-btn" @click="handleForgetPassword">{{ $t('Home.Login.Continue') }} <i class="el-icon-right"></i></el-button>
              </el-form-item>
              <div style="text-align:center;"><el-button type="text" @click="changeLoginMethod(loginMethod==='phone'?'email':'phone', 'forget') ">{{ loginMethod === 'phone' ? 'Reset password using email address' : 'Reset password using Phone Number' }} </el-button></div>
            </el-form>

            <!-- 重置密码 -->
            <el-form v-if="resetPass" label-position="top" label-width="80px" ref="resetPassword" :model="resetPassword" :rules="resetRules" class="login-form">
              <el-form-item :label="$t('Home.Login.Password')" prop="password">
                <el-input type="password" v-model.trim="resetPassword.password" show-password></el-input>
              </el-form-item>
              <el-form-item :label="$t('Home.Login.ConfirmPassword')" prop="checkPassword">
                <el-input type="password" v-model.trim="resetPassword.checkPassword" show-password></el-input>
              </el-form-item>
              <p style="margin-bottom:20px">{{ $t('Home.Register.PasswordCheckRule') }}</p>
              <el-form-item>
                <el-button type="primary" class="login-btn" @click="handleModifyPassword">{{ $t('Home.Login.Sure') }}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="right-banner">
        <LoginBanner></LoginBanner>
      </div>
    </div>
    <div class="isMobile">
      <mobile-login :areaCodeList="areaCodeListMobile" @clickGoogle="isClickGoogle = true" />
    </div>
    <third-party-registration ref="thirdPartyRegistration" v-model="thirdPartyRegistrationVisibled" @registerSuccess="thirdPartyLogin" />
  </div>
</template>

<script>
import API from '@/api'
import { checkEmail, pureNumber, hasCapital, hasLowercase, hasNumber, telephoneNumber, generalPhoneNumber } from '@/util/validate'
import { encrypt, decrypt } from '@/util/encryp.js'
import googleLoginMixin from '../js/googleLogin.js'
import LoginBanner from './components/LoginBanner.vue'
import LoginMethod from './components/LoginMethod.vue'
import MobileLogin from './MLogin.vue'

let validateEmail = (rule, value, callback) => {
  if (checkEmail(value)) {
    callback()
  } else {
    callback(new Error('Please enter your vaild email'))
  }
}
let checkPureNumber = (rules, value, callback) => {
  if (pureNumber(value)) {
    callback()
  } else {
    callback(new Error('Please enter your valid phoneNumber'))
  }
}

let checkPhoneNumber = (rules, value, callback) => {
  if (telephoneNumber(value) || generalPhoneNumber(value)) {
    callback()
  } else {
    callback(new Error('Please enter your valid phoneNumber'))
  }
}

export default {
  components: { LoginBanner, LoginMethod, MobileLogin },
  mixins: [googleLoginMixin],
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('Home.Register.PasswordCheck1')))
      } else if (value.length < 8 || value.length > 20) {
        callback(new Error(this.$t('Home.Register.PasswordCheck2')))
      } else if (!hasCapital(value) || !hasLowercase(value) || !hasNumber(value)) {
        callback(new Error(this.$t('Home.Register.PasswordCheck3')))
      } else {
        callback()
      }
    }

    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the password again'))
      } else if (value !== this.resetPassword.password) {
        callback(new Error('The two passwords are inconsistent!'))
      } else {
        callback()
      }
    }
    return {
      userForm: {
        grant_type: 'password',
        client_id: 'client_general',
        client_secret: 'genera_secret',
        username: localStorage.getItem('remeberPassword') ? localStorage.getItem('remeberPassword').name : '',
        password: localStorage.getItem('remeberPassword') ? localStorage.getItem('remeberPassword').pwd : '',
        phone: '',
        areaCode: '+1'
      },
      forgetForm: {
        email: '',
        areaCode: '+1',
        phone: ''
      },
      loading: false,
      resetPassword: {},
      checked: false,
      forgetPass: false,
      resetPass: false,
      disabled: false,
      checkPassword: '',
      rules: {
        phone: [{ validator: checkPhoneNumber, trigger: 'blur' }, { required: true, message: 'Please enter your vaild Phone Number', trigger: 'blur' }],
        username: [{ validator: validateEmail, trigger: 'blur' }, { required: true, message: 'Please enter your vaild email', trigger: 'blur' }],
        password: [{ required: true, message: 'Please enter the password', trigger: 'blur' }, { min: 6, max: 20, trigger: 'blur', message: 'Please enter a password of 8 to 20 characters' }],
        checkPassword: [{ validator: validatePass2, trigger: 'blur' }, { required: true, message: '', trigger: 'blur' }],
        verificationCode: [{ required: true, message: 'Please enter the verificationCode', trigger: 'blur' }, { validator: checkPureNumber, message: 'Please enter number', trigger: 'blur' }, { min: 6, max: 6, trigger: 'blur', message: 'Please enter the six-digit verification code ' }],
        email: [{ validator: validateEmail, trigger: 'blur' }, { required: true, message: 'Please enter your vaild email', trigger: 'blur' }]
      },
      resetRules: {
        password: [{ required: true, message: 'Please enter the password', trigger: 'blur' }, { min: 8, max: 20, trigger: 'blur', message: 'Please enter a password of 8 to 20 characters' }, { validator: validatePass, trigger: 'blur' }],
        checkPassword: [{ validator: validatePass2, trigger: 'blur' }, { required: true, message: '', trigger: 'blur' }]
      },
      email: '',
      seconds: 0,
      timer: null,
      loadingBtn: false,

      loginMethod: 'email', // 登录方式
      areaCode: '+1', // 默认选择 +1美国区号
      areaCodeList: [],
      areaCodeListMobile: []
    }
  },
  created() {
    this.systemAddressInfo()
    if (this.$route.query.seo === 'logout') {
      this.logOut()
    }
    this.getLocalUserInfo()
    const registerInfo = JSON.parse(localStorage.getItem('registerInfo'))
    if (this.checked) {
      this.$nextTick(() => {
        const userInfo = JSON.parse(localStorage.getItem('remeberPassword'))
        if (userInfo.type === 'phone') {
          this.loginMethod = userInfo.type
          this.userForm.phone = userInfo.phone
          this.userForm.areaCode = userInfo.areaCode || '+1'
        } else {
          this.loginMethod = userInfo.type || 'email'
          this.userForm.username = userInfo.name
        }
        this.userForm.password = decrypt(userInfo.pwd)
      })
    }
    if (registerInfo) {
      this.$nextTick(() => {
        this.userForm.username = registerInfo.email
        this.userForm.phone = registerInfo.phone
        this.userForm.areaCode = registerInfo.areaCode
        this.userForm.password = decrypt(registerInfo.password)
        this.loginMethod = registerInfo.loginMethod
        localStorage.removeItem('registerInfo')
      })
    }
    if (JSON.stringify(this.$store.state.common.ipInfoObjec) === '{}') {
      this.$store.dispatch('common/getOpenIpInfo')
    }

    this.$nextTick(() => {
      let query = this.$route.query
      if (query.token && query.userId) {
        this.autoLogin(query)
      }
      if (query.from === 'register' && query.autoLogin) {
        this.login()
      }
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.$store.commit('set', {
        isPC: document.body.offsetWidth > 1000
      })
    })
  },
  methods: {
    // 校验输入的电话号码（只能为数字）
    checkPhone() {
      this.userForm.phone = this.userForm.phone.replace(/\D/g, '')
    },
    // 校验忘记密码输入的电话号码
    checkForgetPhone() {
      this.forgetForm.phone = this.forgetForm.phone.replace(/\D/g, '')
    },
    // 登入
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (!valid) return
        this.login()
      })
    },
    login() {
      const self = this
      let form = { ...this.userForm }
      let data = new FormData()
      form.password = encrypt(form.password)
      data.append('grant_type', form.grant_type)
      data.append('client_id', form.client_id)
      data.append('client_secret', form.client_secret)
      data.append('type', this.loginMethod)
      if (this.loginMethod === 'phone') {
        data.append('username', `${form.areaCode} ${form.phone}`)
      } else data.append('username', form.username)
      data.append('password', form.password)
      if (self.checked) {
        this.loginMethod === 'phone' ? self.setUserInfo(self.userForm.phone, form.password, this.loginMethod, form.areaCode) : self.setUserInfo(self.userForm.username, form.password, this.loginMethod)
      } else {
        self.clearUserInfo()
      }
      this.loadingBtn = true
      API.login(data).then(this.loginSuccessCb).catch(result => {
        this.$message.error(result.data.message)
      }).finally(() => {
        this.loadingBtn = false
      })
    },
    // 自动登录
    async autoLogin(query) {
      if (this.$store.state.common.token) {
        await API.logout()
        this.$store.dispatch('logOut', { noJump: true })
      }
      API.autoLogin(query).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        if (localStorage.getItem('loginRedirection')) localStorage.removeItem('loginRedirection')
        this.loginSuccessCb(res)
      }).catch(result => {
        this.$message.error(result.data.message)
      })
    },
    setUserInfo(c_name, c_pwd, type, areaCode) {
      let reObj = {}
      if (type === 'phone') {
        reObj.phone = c_name
        reObj.pwd = c_pwd
        reObj.areaCode = areaCode
        reObj.type = type
      } else {
        reObj.name = c_name
        reObj.pwd = c_pwd
        reObj.type = type
      }
      localStorage.setItem('remeberPassword', JSON.stringify(reObj))
    },
    // 读取UserInfo
    getLocalUserInfo: function() {
      if (localStorage.getItem('remeberPassword')) {
        this.checked = true
      }
    },
    // 清除UserInfo
    clearUserInfo: function() {
      localStorage.removeItem('remeberPassword')
    },
    handleForgetPass() {
      this.forgetPass = true
      this.forgetForm.email = this.userForm.username
      this.forgetForm.phone = this.userForm.phone
      this.forgetForm.areaCode = this.userForm.areaCode
      this.$refs.resetPassword && this.$refs.resetPassword.clearValidate()
      this.$refs.loginForm && this.$refs.loginForm.clearValidate()
      this.$refs.forgetForm && this.$refs.forgetForm.clearValidate()
    },

    // 忘记密码操作
    handleForgetPassword() {
      this.$refs.forgetForm.validate((valid) => {
        if (!valid) return
        let form = {
          verificationCode: this.forgetForm.verificationCode
        }
        if (this.loginMethod === 'email') form.email = this.forgetForm.email
        else form.phone = `${this.forgetForm.areaCode} ${this.forgetForm.phone}`
        API.handleForgetPassword(form).then(res => {
          if (res.code !== 10000) return this.$message.error(res.message)
          this.$message.success(this.$t('promptText.msg25'))
          localStorage.setItem('reset_email', this.forgetForm.email)
          this.forgetForm.verificationCode = undefined
          this.resetPass = true
        }).catch(result => {
          this.$message.error(result.data.message)
        })
      })
    },

    // 发送验证码
    sendVertificationCode() {
      if (this.loginMethod === 'email' && !this.forgetForm.email) return this.$message.error(this.$t('promptText.msg26'))
      if (this.loginMethod === 'phone' && !this.forgetForm.phone) return this.$message.error(this.$t('promptText.msg49'))
      this.loading = true
      let data = {}
      if (this.loginMethod === 'email') data.email = this.forgetForm.email
      else data.phone = `${this.forgetForm.areaCode} ${this.forgetForm.phone}`
      API.sendVertificationCode(data).then((res) => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.disabled = true
        this.seconds = 60
        this.timer = setInterval(() => {
          if (this.seconds <= 0) {
            clearInterval(this.timer)
            this.timer = null
            this.disabled = false
            this.$forceUpdate()
            return
          }
          --this.seconds
        }, 1000)
      }).catch(result => {
        this.$message.error(result.data.message)
        this.disabled = false
      }).finally(() => {
        this.loading = false
      })
    },

    // 验证验证码是否正确
    checkVerificationCode() {
      if (this.forgetForm.email && this.forgetForm.verificationCode && this.forgetForm.email !== '' && this.forgetForm.verificationCode !== '') {
        let form = {
          verificationCode: this.forgetForm.verificationCode
        }
        if (this.loginMethod === 'email') form.email = this.forgetForm.email
        else form.phone = `${this.forgetForm.areaCode} ${this.forgetForm.phone}`
        API.checkVerificationCode(form).then(res => {
          // console.log(res)
        }).catch(result => {
          return this.$message.error(result.data.message)
        })
      }
    },

    // 重置密码
    handleModifyPassword() {
      this.$refs.resetPassword.validate(valid => {
        if (!valid) return
        let form = {
          password: encrypt(this.resetPassword.password)
        }
        if (this.loginMethod === 'email') form.email = this.forgetForm.email
        else form.phone = `${this.forgetForm.areaCode} ${this.forgetForm.phone}`
        API.handleModifyPassword(form).then(res => {
          if (res.code !== 10000) return this.$message.error(res.message)
          this.$message.success(this.$t('promptText.msg27'))
          if (this.loginMethod === 'email') this.userForm.username = this.forgetForm.email
          else {
            this.userForm.phone = this.forgetForm.phone
            this.userForm.areaCode = this.forgetForm.areaCode
          }
          this.userForm.password = decrypt(form.password)
          localStorage.removeItem('reset_email')
          this.resetPassword.password = undefined
          this.resetPassword.checkPassword = undefined
          this.forgetPass = false
          this.resetPass = false
        }).catch(result => {
          this.$message.error(result.data.message)
        })
      })
    },
    toLogin() {
      this.forgetPass = false
      this.resetPass = false
    },

    changeLoginMethod(method, type) {
      this.loginMethod = method
      this.userForm.username = ''
      this.userForm.phone = ''
      this.userForm.areaCode = '+1'
      this.userForm.password = ''
      this.$nextTick(() => {
        this.$refs.loginForm.clearValidate()
      })
      if (type === 'forget') {
        this.handleForgetPass()
      }
    },

    backLogin() {
      this.forgetPass = false
      this.resetPass = false
      this.$refs.resetPassword && this.$refs.resetPassword.clearValidate()
      this.$refs.loginForm && this.$refs.loginForm.clearValidate()
      this.$refs.forgetForm && this.$refs.forgetForm.clearValidate()
    },

    systemAddressInfo() {
      API.systemAddressInfo().then(res => {
        this.areaCodeList = res.data
        this.areaCodeListMobile = res.data.map(v => v.areaCode)
      })
    },

    // seo自动登出
    logOut() {
      API.logout().finally(() => {
        localStorage.removeItem('loginRedirection')
        this.$store.dispatch('logOut', { noJump: true })
      })
    },
    jump(path) {
      location.href = path
    }
  }
}
</script>

<style lang="scss" scoped>
#login {
  background: #fff !important;
  font-family: Arial;
}
.isMobile {
  display: none;
}

.login {
  min-height: 100vh;

  .login-left {
    width: 50%;
    box-sizing: border-box;
    padding: 20px 40px;

    .head {
      height: 40px;
      .logo {
        width: 150px;
        img {
          width: 100%;
        }
      }
    }

    .content {
      width: 100%;
      height: calc(100vh - 80px);
      overflow: auto;

      .login-box {
        width: 420px;
        font-size: 14px;
        color: #606266;
        margin-top: 12vh;
        position: relative;

        .back {
          position: absolute;
          top: -50px;
          left: 0;
        }

        h4 {
          color: #303133;
          font-size: 32px;
          margin-bottom: 16px;
        }

        .login-form {
          width: 100%;
          margin-top: 40px;

          .login-btn {
            width: 100%;
            height: 40px;
            border-radius: 2px;
          }

          .verification {
            /deep/ .el-form-item__content{
              display: flex;
            }
          }

          .send-button {
            width: 92px;
            height: 40px;
            border-radius: 2px;
          }

          /deep/ .el-form-item {
            margin-bottom: 20px;
          }
          /deep/ .el-form-item--medium .el-form-item__label {
            width: 100%;
            display: flex;
            line-height: 22px;
            padding-bottom: 4px !important;
          }
          /deep/ .el-form-item__content .el-input__inner {
            border-radius: 2px;
            height: 40px;
          }
        }

        .terms {
          text-align: center;
          font-size: 12px;
          line-height: 18px;
          margin-top: 40px;
        }

        /deep/ .el-input-group__prepend{
          background-color: unset;
        }
      }
    }
  }

  .right-banner {
    width: 50%;
    box-sizing: border-box;
  }
}

.or-box {
  padding: 15px 0 10px 0;
  color: rgb(190, 190, 190);
  div {
    width: 38%;
    height: 1.5px;
    background: rgb(190, 190, 190);
  }
  span {
    padding: 0 15px;
  }
}
/* 移动端样式 */

.mobile-register {
  min-height: calc(100vh - 0.86rem);
  padding: 0.2rem 0.32rem;
  .register-top {
    margin-bottom: 0.36rem;
    h1 {
      font-weight: 600;
      font-size: 0.36rem;
      line-height: 0.54rem;
      color: #4f4f4f;
    }
  }
  .register-btn {
    width: 100%;
    height: 48px;
    border-radius: 4px;
    background: #121e26;
    color: #fff;
    margin-top: 30px;
  }
}
.mobile-login-btton {
  width: 2.32rem;
  height: 0.8rem;
  color: #99c41c;
  border-radius: 4px;
  border: 1px solid #99c41c;
}
.mobile-register /deep/.el-input__inner {
  border-radius:4px !important;
  height: 0.8rem;
}
/deep/.el-input.el-input--suffix > .el-input__inner, .el-input > .el-input__inner {
  border-radius: 4px;
}
.code-button {
  width: 30% !important;
  color: #99c41c;
  display: inline-block;
  height: 46px;
  border: 1px solid #99c41c;
}
.mobile-code-button {
  height: 0.8rem;
  border-radius: 4px;
}
.mobile-register /deep/.el-form-item__content {
  line-height: 0.8rem;
}
.mobile-register /deep/ .is-error {
  height: 1rem !important;
}
.mobile-register-btn {
  margin-top: 0.2rem;
}
.mobile-forget-pass {
  font-weight: 400;
  font-size: 0.28rem;
  line-height: 0.42rem;
  color: #7b7b7b;
}
.mobile-forget-tips {
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.36rem;
  color: #7b7b7b;
}
.mobile-help {
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.36rem;
  color: #7b7b7b;
  padding-top: 0.2rem;
  text-align: center;
}
.button-group{
  margin-top: 0.54rem;
}

/deep/.el-form-item {
  margin-bottom: 12px;
}

@media screen and (max-width: 1000px) {
  .isPC {
    display: none;
  }
  .isMobile {
    display: block;
  }
}

</style>
<style>
.abcRioButton.abcRioButtonLightBlue {
  width: 36px !important;
}
</style>

